import { useSelectedStrategyGroup } from './useSelectedStrategyGroup';

export const useSelectedShareItem = () => {
  const [selectedStrategyGroup] = useSelectedStrategyGroup();
  return selectedStrategyGroup?.labId != null;
};
